// extracted by mini-css-extract-plugin
export var root = "Hero-module--root--OVgDu";
export var content = "Hero-module--content--ltIuC";
export var title = "Hero-module--title--t9lfD";
export var subtitle = "Hero-module--subtitle--skq4L";
export var ctaButton = "Hero-module--ctaButton--BihTJ";
export var ctaLink = "Hero-module--ctaLink--dt5rX";
export var header = "Hero-module--header--cLGmK";